import Cookies from 'js-cookie'

// 设置某个cookie存储
export function setCache(key, value) {
	let result = value
	if (typeof value === 'object' && value != null) {
		result = JSON.stringify(result)
	}
	return Cookies.set(key, result)
}

// 获取某个cookie存储
export function getCache(key) {
	const val = Cookies.get(key)
	try {
		// 需要注意，如果存储的val是一个数值，JSON.parse()会将其String类型转为Number类型
		return JSON.parse(val)
	} catch (e) {
		return val
	}
}

// 删除某个cookie存储
export function removeCache(key) {
	return Cookies.remove(key)
}

// 设置local存储
export function setLocal(key, value) {
	let result = value
	if (typeof value === 'object' && value != null) {
		result = JSON.stringify(result)
	}
	return localStorage.setItem(key, result)
}

// 获取local存储
export function getLocal(key) {
	// 判断一下，避免为空时，在接收出被转为字符串的"null"
	const val = localStorage.getItem(key) ? localStorage.getItem(key) : ''
	try {
		// 需要注意，如果存储的val是一个数值，JSON.parse()会将其String类型转为Number类型
		return JSON.parse(val)
	} catch (e) {
		return val
	}
}

// 删除local存储
export function removeLocal(key) {
	return localStorage.removeItem(key)
}
